import { useState, useEffect, useContext } from 'react';
import { ProductContext } from '../ProductsContext';
import {
  getProducts,
  getProductById,
  getProductByFilter,
  searchProduct,
  filterProduct,
  countCategories,
  countType
} from '../services/ProductService'

export const useProducts = (filters = {}) => {
  const [products, setProducts] = useState([]);
  const [productsCountCategories, setProductsCountCategories] = useState([]);
  const [productsCountType, setProductsCountType] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchProducts = async () => {
    try {
      setLoading(true);
      const response = await getProducts();
      setProducts(response.data);

      setLoading(false);
    } catch (err) {
      setError('Failed to fetch products');
      setLoading(false);
    } finally {
      setLoading(false);
    }
    setLoading(false);
  };

  const searchProductPost = async (param) => {
    setLoading(true);
    try {
      const response = await searchProduct(param);
      setProducts(response.data);
      setLoading(false);
    } catch (err) {
      setError('Failed to fetch products');
    } finally {
      setLoading(false);
    }
  };

  const filterProductPost = async (param) => {
    setLoading(true);
    try {
      const response = await filterProduct(param);
      setProducts(response.data);

      setLoading(false);
    } catch (err) {
      setError('Failed to fetch products');
    } finally {
      setLoading(false);
    }
  };

  const countCategoryProduct = async () => {
    try {
      setLoading(true);
      const response = await countCategories();

      setProductsCountCategories(response.data);
      setLoading(false);
    } catch (err) {
      setError('Failed to fetch products');
    } finally {
      setLoading(false);
    }
  };

  const countTypeProduct = async () => {
    try {
      setLoading(true);
      const response = await countType();

      setProductsCountType(response.data);
      setLoading(false);
    } catch (err) {
      setError('Failed to fetch products');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
    countCategoryProduct();
    countTypeProduct();
  }, []);

  return {
    products,
    productsCountCategories,
    productsCountType,
    loading,
    fetchProducts,
    searchProductPost,
    filterProductPost,
    countCategoryProduct,
    countTypeProduct
  };
};
